import * as ng from 'angular';

export const ContainerBottomReachedOnScroll = () => (<angular.IDirective>{

  restrict: 'A',
  link: (scope: any, element: JQLite, attrs: any) => {
    let raw = element[0];
    scope.bottomReached = false;

    element.on('scroll', () => {
      if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
        scope.bottomReached = true;
        scope.$apply(attrs.scrolly);
      }
    });
  }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/container-bottom-rached-on-scroll/container-bottom-rached-on-scroll.directive.ts